import { useRef, useState } from 'react';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';
import { Pagination as SwiperPagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import styles from './Mobile.module.scss';
import { StakingCard } from './StakingCard';
import { Pagination } from './Pagination';
import { useFm } from '@web3/base-hooks';
import { useBbSolConfigContext } from '@/hooks/useBboSolInfo';

export const Mobile = () => {
  const fm = useFm();

  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef<SwiperClass>();
  const {
    solConfig: { partners },
  } = useBbSolConfigContext();

  const handlePaginationClick = (index: number) => {
    if (swiperRef.current) {
      // 使用 slideToLoop 来处理循环模式下的跳转
      swiperRef.current.slideToLoop(index, 500);
    }
  };

  return (
    <div className={styles.container} id={'bbsolSlidesMobile'}>
      <h2 className={styles.title}>{fm('bbSOLDeFiHighlights')}</h2>
      {partners && partners.length > 0 && (
        <>
          <div className={styles.sliderWrapper}>
            <Swiper
              className={styles.slider}
              modules={[SwiperPagination, Autoplay]}
              spaceBetween={20}
              loop={true}
              rewind={false}
              watchSlidesProgress={true}
              allowTouchMove={true}
              speed={500}
              observer={true}
              observeParents={true}
              preventInteractionOnTransition={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
              onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
              }}
            >
              {partners.map((slide, index) => (
                <SwiperSlide key={index}>
                  <StakingCard data={slide} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className={styles.stepDescription}>
            {partners?.[activeIndex]?.stepDescription}
          </div>

          <div className={styles.stepWrapper}>
            {partners?.[activeIndex]?.steps.map((step, index) => (
              <div className={styles.step} key={step}>
                <div className={styles.stepIcon}>{index + 1}</div>
                <div className={styles.stepText}>{step}</div>
              </div>
            ))}
          </div>

          <div className={styles.pagination}>
            <Pagination
              total={partners.length}
              active={activeIndex}
              onPageChange={handlePaginationClick}
            />
          </div>
        </>
      )}
    </div>
  );
};
